import React from "react";
import PropTypes from "prop-types";
import { applyTransformations } from "../../utils";

import * as styles from "./styles.module.scss";
import Link from "../link/component";

const FeaturedPost = (props) => {
  const postData = props.post.data.attributes;

  let src =
    postData.case_study_metadata && postData.case_study_metadata.thumbnail
      ? postData.case_study_metadata.thumbnail.data?.attributes?.url
      : false;
  if (src) {
    const path = new URL(src).pathname;
    src = applyTransformations(`https://${process.env.IMGIX_DOMAIN}${path}`, {
      w: 600
    });
  } else {
    return null;
  }

  const component = (
    <div className="container-wrapper py-6 container-lg col-sm-10 col-md-12 p-responsive height-full">
      <div
        className={`d-flex flex-column flex-lg-row flex-md-items-center height-full ${styles.container}`}
      >
        <div className="col-md-8 col-image-container container-lg padding-r height-full">
          <img
            style={{ borderRadius: "50px" }}
            src={src}
            alt={postData.case_study_metadata.thumbnail.data.attributes.alternativeText}
          />
        </div>

        <div className={`col-md-8 padding-r`}>
          <h2>{postData.case_study_metadata.title}</h2>
          {postData.seo_description ? <p>{postData.seo_description}</p> : null}
          <Link to={`/knowledge-hub/${postData.slug}`} className="btn btn-primary">
            Read More
          </Link>
        </div>
      </div>
    </div>
  );

  return props.background_color ? (
    <div style={{ backgroundColor: props.background_color }}>{component}</div>
  ) : (
    component
  );
};

FeaturedPost.propTypes = {
  post: PropTypes.object,
  background_color: PropTypes.string
};

export default FeaturedPost;
